import { USERS } from "../../Constants/Endpoints";
import { ApiRequestInterceptor } from "../apiRequest";

export const fetchLoginGoogle = async (googleToken) => {
    const method = "POST";

    const body = {
        token: googleToken,
    };

    const response = await ApiRequestInterceptor(
        USERS.loginGoogle,
        method,
        body
    );

    const { code, data } = response;

    // ✅ LOGIN CORRECTO (AHORA VALIDAMOS token)
    if (code === 200 && data?.token) {
        // Guardamos solo lo necesario
        localStorage.setItem(
            "logindata",
            JSON.stringify({
                code: 200,
                data: {
                    token: data.token,
                    userId: data.userId,
                    role: data.role,
                    name: data.name,
                    email: data.email,
                    phone: data.phone || "",
                    delivery: data.delivery || { direccion: "", lat: null, lng: null },
                },
            })
        );

        // Si no tiene teléfono, marcamos perfil como incompleto para el guard global
        if (!data.phone) {
            localStorage.setItem("profileIncomplete", "true");
        } else {
            localStorage.removeItem("profileIncomplete");
        }

        window.dispatchEvent(new Event("authChange"));

        return {
            statusCode: 200,
            ...data,
        };
    }

    // ❌ Token inválido
    if (code === 401) {
        return {
            statusCode: 401,
            message: data?.message || "Token de Google inválido",
        };
    }

    return {
        statusCode: code || 500,
        message: data?.message || "Error en login con Google",
    };
};